import { Component, Inject, OnInit, ViewChild } from '@angular/core';

import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSelectionList } from '@angular/material/list';

import * as _ from 'lodash';

import { AppService } from 'src/app/app.service';
import {TabitPayService} from "../../tabit-pay.service";

@Component({
  selector: 'app-offer-request-dialog',
  standalone: false,
  templateUrl: './offer-request-dialog.component.html',
  styleUrl: './offer-request-dialog.component.scss',
})
export class OfferRequestDialogComponent {
	$storage: any;
	total: number = 0;
	totalOrderDiscount: number = 0;

	offers: {
		_id: string,
		id: string,
		name: string;
		price: number;
		selected: boolean;
		amount: number;
		_diner: any;
	}[];
	offersGB;
	loading;

	@ViewChild('list') list: MatSelectionList;

	constructor(
		public appService: AppService,
		public dialogRef: MatDialogRef<OfferRequestDialogComponent>,
		public tabitPayService: TabitPayService,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.$storage = this.data.$storage;
		this.offers = _.cloneDeep(this.data.pending);
		let gb = this.offersGB = [], target;
		this.offers.forEach(o => {
			target = gb.find(g => g.diner == o._diner.diner);
			if (!target) {
				target = {...o._diner, offers: []};
				gb.push(target);
			}
			target.offers.push(o);
		});
	}

	cancel() {
		this.dialogRef.close();
	}
	onOfferSelected(offer, list, ev) {
		if (ev) ev.stopPropagation();
		offer.selected = !offer.selected;
		let diner = this.offersGB.find(g => g.diner.includes(offer._diner.diner));
		if (offer.selected) {
			let wasNotSelected;
			for (let i = 0; i < diner.offers.length; i++) {
				offer = diner.offers[i];
				if (!offer.selected) {
					wasNotSelected = true;
					break;
				}
			}
			if (wasNotSelected) diner.selected = false;
			else diner.selected = true;
		} else {
			diner.selected = false;
		}
		this.calculateTotal(list);

	}
	onDinerSelect(diner, list) {
		let wasNotSelected, offer;
		for (let i = 0; i < diner.offers.length; i++) {
			offer = diner.offers[i];
			if (!offer.selected) {
				wasNotSelected = true;
				break;
			}
		}
		if (wasNotSelected) diner.offers.forEach(o => o.selected = true);
		else diner.offers.forEach(o => o.selected = false);
		this.calculateTotal(list);
	}
	calculateTotal(list) {
		let total = 0;
		this.offers.forEach(item => {
			if (item.price && item.selected) {
				total += item.amount;
			}
		});
		this.total = total;
	}

	async approveSelected() {
		try {
			await this.appService.confirm({content: 'OAT.confirm_approve_selected_requests'});
		} catch (e) {
			return
		}
		try {
			const payload = this.getSelectedOffers();
			this.loading = true;
			await this.tabitPayService.approvePending(payload);
		} catch (e) {
			this.loading = false;
			return;
		}
		this.dialogRef.close();
	}
	async declineSelected() {
		try {
			await this.appService.confirm({content: 'OAT.confirm_decline_selected_requests'});
		} catch (e) {
			return
		}
		try {
			const payload = this.getSelectedOffers();
			this.loading = true;
			await this.tabitPayService.deletePending(payload);
		} catch (e) {
			this.loading = false;
			return;
		}
		this.dialogRef.close();
	}

	getSelectedOffers() {
		let result = {
			orderedOffers: [],
			orderedItems: []
		};
		this.offers.forEach(item => {
			const pending = this.$storage.order._order.pending;
			if (item.selected) {
				const offer = pending.orderedOffers.find(o => o._id == item._id);
				result.orderedOffers.push(offer);
				offer.orderedItems.forEach(itemId => {
					const item = pending.orderedItems.find(oi => oi._id == itemId);
					result.orderedItems.push(item)
				});
			}
		})
		return result;
	}

}

